<template>
  <div>
    <el-row>
      <el-dropdown @command="addMonitor" v-if="listOperations.some(func => func.name.includes('add'))">
        <el-button type="primary">添加API监控<i class="el-icon-arrow-down el-icon--right"></i></el-button>


        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="one"><img src="@/assets/one.png"
                                              style="width:20px;height: 20px;margin-right: 10px">添加单API监控
          </el-dropdown-item>
          <el-dropdown-item command="more"><img src="@/assets/more.png"
                                                style="width:20px;height: 20px;margin-right: 10px">添加多API监控
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="warning" @click="exportAll" style="margin-left:10px"
                 v-if="listOperations.some(func => func.name.includes('export'))">导出
      </el-button>
      <el-upload style="display: inline-block;margin-left: 10px"
                 :action="apiUrl+'apimonitor/importJson'"
                 :on-success="handleUploadSuccess"
                 :on-error="handleUploadError"
                 :before-upload="beforeUpload">
        <el-button type="primary"
                   v-if="listOperations.some(func => func.name.includes('import'))">导入
        </el-button>
      </el-upload>
      <div style="float: right">
        <el-button type="text" style="margin-right: 20px" @click="showReport"
                   v-if="listOperations.some(func => func.name.includes('report'))">查看日报/周报/月报
        </el-button>
        <el-input class="search"
                  placeholder="请输入名称"
                  v-model="condition"
                  @keyup.enter.native="initMonitorList"
                  style="width: 300px">
          <el-select v-model="monitorStatus" slot="prepend" placeholder="请选择" style="width: 100px">
            <el-option v-for="(option, index) in selectList"
                       :key="index"
                       :value="option.type"
                       :label="option.value"></el-option>
          </el-select>
          <el-button slot="append" icon="el-icon-search" @click="initMonitorList"></el-button>
        </el-input>
      </div>
    </el-row>
    <el-table :data="tableData" style="width: 100%"
              @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column align="center" prop="group" label="所属系统"></el-table-column>
      <el-table-column align="center" prop="monitorType" label="类型">
        <template slot-scope="scope">
          <!--          <span v-if="scope.row.type=='SINGLE'">单API</span>-->
          <!--          <span v-if="scope.row.type=='SEQUENCE'">多API</span>-->
          <div v-if="scope.row.type=='SINGLE'">
            <img src="@/assets/one.png" style="width:25px;height: 25px;">
          </div>
          <div v-if="scope.row.type=='SEQUENCE'">
            <img src="@/assets/more.png" style="width:30px;height: 30px;">
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="name" label="名称">
        <template slot-scope="scope">
          <el-button type="text" @click="showLog(scope.row)">{{ scope.row.name }}</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="status" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.monitorStatus== 0">未监控</span>
          <span v-if="scope.row.monitorStatus== 2" style="color: #00a65a">正常</span>
          <span v-if="scope.row.monitorStatus== 3" style="color: red">有故障</span>
          <!--          <span v-if="scope.row.enable== 1 && scope.row.status==0" style="color: red">有故障</span>-->
          <!--          <span v-if="scope.row.enable== 1 && scope.row.status==1" style="color: #00a65a">正常</span>-->
          <!--          <span v-if="scope.row.enable== 0 && scope.row.status==0">未监控</span>-->
        </template>
      </el-table-column>
      <el-table-column align="center" prop="frequency" label="监控频率">
        <template slot-scope="scope">
          <span v-if="scope.row.frequency=='THIRTY'">30秒</span>
          <span v-if="scope.row.frequency=='SIXTY'">1分钟</span>
          <span v-if="scope.row.frequency=='FIVEMINUTES'">5分钟</span>
          <span v-if="scope.row.frequency=='TENMINUTES'">10分钟</span>
          <span v-if="scope.row.frequency=='THIRTYMINUTES'">30分钟</span>
          <span v-if="scope.row.frequency=='ONEHOUR'">1小时</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="availability" label="可用率"></el-table-column>
      <el-table-column align="center" prop="respTime" label="平均响应时间" width="150"></el-table-column>
      <el-table-column align="center" label="操作" width="200">
        <template v-slot="{row}">
          <span v-if="row.enable==0">
            <el-button type="primary" size="mini" icon="el-icon-caret-right" title="启动" @click="onApi(row)"
                       v-if="listOperations.some(func => func.name.includes('start'))"></el-button>
          </span>
          <span v-if="row.enable==1" style="font-size: 20px">
          <el-button type="success" size="mini" icon="el-icon-video-pause" title="停止" @click="onApi(row)"
                     v-if="listOperations.some(func => func.name.includes('stop'))"></el-button>
          </span>
          <el-button style="margin-left: 10px" type="primary" size="mini" icon="el-icon-s-tools" title="配置"
                     @click="deployApi(row)"
                     v-if="listOperations.some(func => func.name.includes('deploy'))"></el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete" title="删除" @click="delOneApi(row)"
                     v-if="listOperations.some(func => func.name.includes('del'))"></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="oneTitle" :visible="monitorView" width="70%"
               :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false"
               :modal-append-to-body="false">
      <el-form :model="oneForm" :rules="rules" ref="oneForm" class="demo-ruleForm">
        <el-form-item label="所属系统" prop="group" label-width="135px">
          <el-select v-model="oneForm.group" placeholder="请选择">
            <el-option
              v-for="item in systemList"
              :key="item.name"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
          <el-button type="primary" icon="el-icon-circle-plus-outline" style="float: right" size="medium"
                     @click="addSystem"></el-button>
        </el-form-item>
        <el-form-item label="监控名称" prop="name" label-width="135px">
          <el-input v-model="oneForm.name"></el-input>
        </el-form-item>
        <el-form-item label="API类型" prop="httpMethod" label-width="135px">
          <el-radio-group v-model="oneForm.httpMethod">
            <el-radio label="GET" value="GET"></el-radio>
            <el-radio label="POST" value="POST"></el-radio>
            <el-radio disabled label="HEAD" value="HEAD"></el-radio>
            <el-radio disabled label="PUT" value="PUT"></el-radio>
            <el-radio disabled label="DELETE" value="DELETE"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="API地址" prop="url" label-width="135px">
          <el-input v-model="oneForm.url" @blur="checkApi"></el-input>
        </el-form-item>
        <el-form-item label="监控频率" prop="frequency" label-width="135px">
          <el-radio-group v-model="oneForm.frequency">
            <el-radio :label="30" value="30秒">30秒</el-radio>
            <el-radio :label="60" value="1分钟">1分钟</el-radio>
            <el-radio :label="300" value="5分钟">5分钟</el-radio>
            <el-radio :label="600" value="10分钟">10分钟</el-radio>
            <el-radio :label="1800" value="30分钟">30分钟</el-radio>
            <el-radio :label="3600" value="1小时">1小时</el-radio>
            <el-radio label="free" value="自定义">自定义</el-radio>
          </el-radio-group>
          <span v-if="oneForm.frequency=='free'">
            <el-input style="width:80px;margin-left: 10px;margin-right: 3px" size="mini"
                      v-model="oneForm.freeFrequency"></el-input>秒
          </span>

        </el-form-item>
        <el-form-item label="重试次数" prop="retryNum" label-width="135px">
          <el-radio-group v-model="oneForm.retryNum">
            <el-radio :label="1" value="1">1</el-radio>
            <el-radio :label="2" value="2">2</el-radio>
            <el-radio :label="3" value="3">3</el-radio>
            <el-radio :label="4" value="4">4</el-radio>
            <el-radio :label="5" value="5">5</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="请求头部" prop="headers" label-width="135px">
          <el-input type="textarea" :rows="3" :placeholder="request" v-model="oneForm.headers"></el-input>
        </el-form-item>
        <el-form-item label="请求参数" prop="parameters" label-width="135px">
          <el-input type="textarea" :rows="3" :placeholder="param" v-model="oneForm.parameters"></el-input>
        </el-form-item>
        <el-form-item label="结果校验" label-width="135px">
          <el-col :span="7">
            <el-select v-model="oneForm.conditionType" clearable>
              <el-option label="响应码" value="STATUSCODE"></el-option>
              <el-option label="内容包含" value="CONTAINS"></el-option>
              <el-option label="内容不包含" value="DOESNT_CONTAIN"></el-option>
              <el-option label="JSON主要对象" value="DEFAULT"></el-option>
            </el-select>
          </el-col>
          <el-col :span="17">
            <el-input style="margin-left: 5px" label-width="10px" v-model="oneForm.condition"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="通知邮件/微信地址" prop="remark" label-width="135px">
          <span style="display:inline-block;width: 700px">这里支持邮箱或者企业微信agentId,邮箱用$$开头，微信agentId用##开头,多个参数用英文逗号分隔，例如：
$$xiangqh@butel.com,$$ninghf@butel.com,##1000002</span>
          <el-input type="textarea" :rows="3" v-model="oneForm.remark"></el-input>
        </el-form-item>
        <el-form-item label="告警邮件发送频率" prop="mailfrequency" label-width="135px">
          <el-radio-group v-model="oneForm.mailfrequency">
            <el-radio :label="30" value="30秒">30秒</el-radio>
            <el-radio :label="60" value="1分钟">1分钟</el-radio>
            <el-radio :label="300" value="5分钟">5分钟</el-radio>
            <el-radio :label="600" value="10分钟">10分钟</el-radio>
            <el-radio :label="0" value="不发送">不发送</el-radio>
            <el-radio label="free" value="自定义">自定义</el-radio>
          </el-radio-group>
          <span v-if="oneForm.mailfrequency=='free'">
            <el-input style="width:80px;margin-left: 10px;margin-right: 3px" size="mini"
                      v-model="oneForm.freeMailfrequency"></el-input>秒
          </span>
        </el-form-item>
      </el-form>
      <el-row style="text-align:center;margin-top: 20px">
        <el-button type="primary" @click="saveOneConfirm('false')">提 交</el-button>
        <el-button type="success" @click="saveOneApiMonitor('true')">测 试</el-button>
        <el-button @click="monitorView = false">取 消</el-button>
      </el-row>
    </el-dialog>
    <el-dialog :title="moreTitle" :visible="moremonitorView" width="70%"
               :show-close="false"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :modal-append-to-body="false">
      <el-form :model="moreForm" :rules="rules" ref="moreForm" class="demo-ruleForm">
        <el-form-item label="所属系统" prop="group" label-width="135px">
          <el-select v-model="moreForm.group" placeholder="请选择">
            <el-option
              v-for="item in systemList"
              :key="item.name"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
          <el-button type="primary" icon="el-icon-circle-plus-outline" style="float: right" size="medium"
                     @click="addSystem"></el-button>
        </el-form-item>
        <el-form-item label="监控名称" prop="name" label-width="135px">
          <el-input v-model="moreForm.name"></el-input>
        </el-form-item>
        <el-form-item label="监控频率" prop="frequency" label-width="135px">
          <el-select v-model="moreForm.frequency" style="width: 250px" placeholder="支持输入自定义频率(单位:秒)" allow-create
                     filterable clearable>
            <el-option label="30秒" :value="30">30秒</el-option>
            <el-option label="1分钟" :value="60">1分钟</el-option>
            <el-option label="5分钟" :value="300">5分钟</el-option>
            <el-option label="10分钟" :value="600">10分钟</el-option>
            <el-option label="30分钟" :value="6000">30分钟</el-option>
            <el-option label="1小时" :value="12000">1小时</el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="API管理" prop="apiMan" label-width="135px">
          <el-button type="info" plain @click="importScript">导入postman脚本</el-button>
          <!--          <el-button type="info" plain style="margin-left: 15px" @click="testApi">测试API</el-button>-->
          <el-table :data="moreData" style="width: 100%" empty-text="--">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column align="center" prop="httpMethod" label="API类型"></el-table-column>
            <el-table-column align="center" prop="url" label="API地址"></el-table-column>
            <el-table-column align="center" label="操作" width="200">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" icon="el-icon-edit"
                           @click="editMoreApi(scope.$index,scope.row)"></el-button>
                <el-button type="primary" size="mini" icon="el-icon-delete"
                           @click="delEditApi(scope.$index,scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button icon="el-icon-plus" style="float: right" @click="addNewApi" size="mini"></el-button>
        </el-form-item>
        <el-form-item label="通知邮件/微信地址" prop="remark" label-width="135px" style="margin-top: -20px;">
          <span style="display:inline-block;width: 700px">这里支持邮箱或者企业微信agentId,邮箱用$$开头，微信agentId用##开头,多个参数用英文逗号分隔，例如：
$$xiangqh@butel.com,$$ninghf@butel.com,##1000002</span>
          <el-input type="textarea" :rows="3" v-model="moreForm.remark"></el-input>
        </el-form-item>
        <el-form-item label="告警邮件发送频率" prop="mailfrequency" label-width="135px">
          <el-select v-model="moreForm.mailfrequency" placeholder="支持输入自定义频率(单位:秒)"
                     style="width: 250px" clearable
                     allow-create filterable>
            <el-option label="30秒" :value="30">30秒</el-option>
            <el-option label="1分钟" :value="60">1分钟</el-option>
            <el-option label="5分钟" :value="300">5分钟</el-option>
            <el-option label="10分钟" :value="600">10分钟</el-option>
            <el-option label="不发送" :value="0">不发送</el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-row style="text-align:center;margin-top: 20px">
        <el-button type="primary" @click="saveMoreConfirm('false')">提 交</el-button>
        <el-button type="success" @click="saveMoreApiMonitor('true')">测 试</el-button>
        <el-button @click="moremonitorView = false">取 消</el-button>
      </el-row>
    </el-dialog>
    <el-dialog title="导入postman脚本" :visible="importView" :show-close="false"
               :close-on-click-modal="false" :close-on-press-escape="false" width="45%">
      <div style="margin-bottom: 10px;font-size: 15px">有关postman脚本的使用，请查看
        <a href="https://www.jianshu.com/p/e16e24e9abc7" target="_blank">操作指引</a>
        <div style="margin-top: 10px">注意：仅支持Collection v2版本</div>
      </div>
      <el-input
        type="textarea"
        :rows="8"
        v-model="postmanText"
        placeholder="复制postman脚本到这里...">
      </el-input>
      <div style="text-align: center;margin-top: 10px">
        <el-button type="primary" @click="exportPostman">导 入</el-button>
        <el-button type="primary" @click="importView=false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加系统" :visible="addSystemView" :show-close="false"
               :close-on-click-modal="false"
               :close-on-press-escape="false" width="30%">
      <el-form label-position="left"
               :model="addSystemForm" :rules="rules" ref="addSystemForm" label-width="80px">
        <el-form-item label="系统名称" style="width: 320px" prop="systemName">
          <el-input v-model="addSystemForm.systemName"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: center;">
        <el-button type="primary" @click="saveSystem">保 存</el-button>
        <el-button type="primary" @click="addSystemView=false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="apiTitle" :visible="APIView"
               @close="editClose" :close-on-click-modal="false" :close-on-press-escape="false" width="50%">
      <el-form :model="apiForm" :rules="rules" ref="apiForm" label-width="80px">
        <el-form-item label="API类型" prop="httpMethod" label-width="135px">
          <el-radio-group v-model="apiForm.httpMethod">
            <el-radio label="GET"></el-radio>
            <el-radio label="POST"></el-radio>
            <el-radio disabled label="HEAD"></el-radio>
            <el-radio disabled label="PUT"></el-radio>
            <el-radio disabled label="DELETE"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="API地址" prop="url" label-width="135px">
          <el-input v-model="apiForm.url"></el-input>
        </el-form-item>
        <el-form-item label="请求头部" prop="headers" label-width="135px">
          <el-input type="textarea" :rows="3" :placeholder="request" v-model="apiForm.headers"></el-input>
        </el-form-item>
        <el-form-item label="请求参数" prop="parameters" label-width="135px">
          <el-input type="textarea" :rows="3" :placeholder="param" v-model="apiForm.parameters"></el-input>
        </el-form-item>
        <el-form-item label="结果校验" label-width="135px">
          <el-col :span="7">
            <el-select v-model="apiForm.conditionType" clearable>
              <el-option label="响应码" value="STATUSCODE"></el-option>
              <el-option label="内容包含" value="CONTAINS"></el-option>
              <el-option label="内容不包含" value="DOESNT_CONTAIN"></el-option>
              <el-option label="JSON主要对象" value="DEFAULT"></el-option>
            </el-select>
          </el-col>
          <el-col :span="17">
            <el-input style="margin-left: 5px" label-width="10px" v-model="apiForm.condition"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="结果提取" prop="resulttype" label-width="135px">
          <el-radio-group v-model="apiForm.resulttype">
            <el-radio label="1">xPath</el-radio>
            <el-radio label="2">jsonPath</el-radio>
          </el-radio-group>
          <span style="margin-left: 50px">查看<a href="https://www.jianshu.com/p/e404edb8c14f" target="_blank">xPath和jsonPath的使用教程</a></span>
          <el-input type="textarea" :rows="3" :placeholder="variable" v-model="apiForm.variables"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: center;">
        <el-button type="primary" @click="saveEditApi">保 存</el-button>
        <el-button type="primary" @click="APIView=false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="测试结果" :visible.sync="resultTestView"
               :close-on-click-modal="false"
               :close-on-press-escape="false" width="50%">
      <el-input
        type="textarea"
        :rows="20"
        placeholder="测试结果"
        v-model="result">
      </el-input>
    </el-dialog>
    <el-dialog title="测试结果" :visible.sync="moreresultTestView"
               :close-on-click-modal="false"
               :close-on-press-escape="false" width="65%">
      <el-table :data="testResultData" style="width: 100%">
        <el-table-column align="center" prop="url" label="API地址" width="350"></el-table-column>
        <el-table-column align="center" prop="httpMethod" label="API类型"></el-table-column>
        <el-table-column align="center" prop="testResult" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.testStatus==1">成功</span>
            <span v-if="scope.row.testStatus==0">失败</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" width="300" align="center" prop="testResult"
                         label="测试结果"></el-table-column>
      </el-table>
    </el-dialog>
    <el-pagination
      class="fy"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElement"
    ></el-pagination>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
  name: "Apimonitor",
  data() {
    return {
      file: "",
      // showExport: false,
      allGuid: "",
      condition: "",
      selectList: [
        {
          type: -1,
          value: '全部'
        }, {
          type: 0,
          value: '未监控'
        }, {
          type: 2,
          value: '正常'
        }, {
          type: 3,
          value: '有故障'
        }],
      // searchSelect: "",
      postmanText: "",
      addSystemView: false,
      apiLogShow: false,
      tipView: false,
      APIView: false,
      importView: false,
      // apiTestView: false,
      resultTestView: false,
      moreresultTestView: false,
      apiTitle: "",
      oneTitle: "",
      moreTitle: "",
      result: "",
      enableShow: false,
      systemList: [],
      testResultData: [],
      addSystemForm: {
        systemName: ""
      },
      // apiTestData: [],
      apiForm: {
        httpMethod: "",
        url: "",
        headers: "",
        parameters: "",
        conditionType: "",
        condition: "",
        variables: "",
        resulttype: ""
      },
      moreForm: {
        group: "",
        name: "",
        frequency: "",
        apiMan: "",
        remark: "",
        mailfrequency: ""
      },
      oneForm: {
        group: "",
        name: "",
        httpMethod: "",
        url: "",
        frequency: "",
        headers: "",
        parameters: "",
        conditionType: "",
        condition: "",
        remark: "",
        mailfrequency: "",
        freeFrequency: "",
        freeMailfrequency: "",
        retryNum: "",
      },
      request: "头部key::头部value\n头部key::头部value",
      param: "JSON格式 ({ key : value })",
      variable: "$$变量名::xPath路径\n$$变量名::xPath路径",
      monitorView: false,
      moremonitorView: false,
      currentPage: 1,
      pageSize: 10,
      totalElement: 0,
      systemId: null,
      apiId: null,
      apiName: "",
      apiGuid: "",
      tableData: [],
      // objItem: {},
      editIndex: "",
      moreData: [],
      rules: {
        group: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        httpMethod: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        url: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        monitorRate: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        frequency: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
      },
      checkRepeat: false,
      monitorStatus: -1
    }
  },
  created() {
    this.getListOperations('alarm/apimonitor')
    if (!this.currentMenu) {
      return
    }
    this.initMonitorList();
  },
  computed: {
    ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
  },
  methods: {
    ...mapMutations(['getListOperations']),
    beforeUpload(file) {
      let param = new FormData();  // 创建form对象
      param.append('file', file, file.name); //通过append向form对象添加数据
      //通过axios上传文件
      this.$axios.post(this.apiUrl + 'apimonitor/importJson', param)
        .then(response => {
          if (response.data.code == 0) {
            this.$message.success(response.data.msg)
            this.initMonitorList();
          } else {
            this.$message.error(response.data.msg)
          }
        })
        .catch(error => {
          console.log(error);
        });
      return false; // 阻止默认上传行为
    },
    handleUploadSuccess(response, file, fileList) {
      //处理上传成功后的回调
    },
    handleUploadError(response, file, fileList) {
      //处理上传失败后的回调
    },
    exportAll() {
      let url
      if (this.allGuid == "") {
        url = this.apiUrl + 'apimonitor/exportJson/' + "\"\"";
      } else {
        url = this.apiUrl + 'apimonitor/exportJson/' + this.allGuid;
      }

      window.location.href = url;

      this.allGuid = ""
    },
    handleSelectionChange(e) {
      if (e && e.length > 0) {
        // this.showExport = true;
        let arr = []
        e.forEach(e => {
          arr.push(e.guid)
        })
        this.allGuid = arr.join(",")
      } else {
        this.allGuid = ""
        // this.showExport = false;
      }
    },
    showReport() {
      this.$router.push({
        path: 'reportList',
        name: 'ReportList'
      })
    },
    //添加单API的接口校验
    checkApi() {
      if (this.oneForm.url && this.oneForm.group && this.oneTitle == "添加单API监控") {
        let data = {
          'url': this.oneForm.url,
          'group': this.oneForm.group,
        };
        this.$axios.post(this.apiUrl + 'apimonitor/checkUrl', data)
          .then(({data: {msg, data, code}}) => {
            if (code == -1) {
              this.$message({
                  duration: 5000,
                  showClose: true,
                  message: "此系统下已经存在相同的URL，请重新输入！",
                  type: 'error'
                }
              )
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    showLog(item) {
      this.$router.push({
        path: 'apilog',
        name: 'Apilog',
        query: {
          apiName: item.name,
          apiGuid: item.guid
        }
      })
    },
    initMonitorList() {
      let data = {
        'pageNo': this.currentPage,
        'pageSize': this.pageSize,
        'condition': this.condition,
        'monitorStatus': this.monitorStatus,
      };
      this.$axios.post(this.apiUrl + 'apimonitor/list', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.tableData = data.list;
            this.totalElement = data.total
          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    delEditApi(index, row) {
      this.moreData.splice(index, 1);
    },
    saveEditApi() {
      if (this.editIndex == "") {
        let obj = {
          guid: "",
          httpMethod: this.apiForm.httpMethod,
          url: this.apiForm.url,
          headers: this.apiForm.headers,
          parameters: this.apiForm.parameters,
          conditionType: this.apiForm.conditionType,
          // text: this.apiForm.text,
          condition: this.apiForm.condition,
          resulttype: this.apiForm.resulttype,
          variables: this.apiForm.variables,
        };
        this.moreData.push(obj);
      } else {
        let guid = this.moreData[this.editIndex].guid;
        this.moreData.splice(this.editIndex, 1,
          {
            guid: guid,
            httpMethod: this.apiForm.httpMethod,
            url: this.apiForm.url,
            headers: this.apiForm.headers,
            parameters: this.apiForm.parameters,
            conditionType: this.apiForm.conditionType,
            // text: this.apiForm.text,
            condition: this.apiForm.condition,
            resulttype: this.apiForm.resulttype,
            variables: this.apiForm.variables,
          }
        );
      }
      this.APIView = false;
    },
    saveMoreConfirm(flag) {
      this.checkRepeat = false;
      if (this.moreData && this.moreData.length > 0) {
        this.moreData.forEach(e => {
          let data = {
            'url': e.url,
            'group': this.moreForm.group,
          };
          this.$axios.post(this.apiUrl + 'apimonitor/checkUrl', data)
            .then(({data: {msg, data, code}}) => {
              if (code == -1) {
                e.checkRepeat = true
              }
            })
            .catch(err => {
              console.log(err)
            })
        })
        for (let i = 0; i < this.moreData.length; i++) {
          if (this.moreData[i].checkRepeat) {
            this.checkRepeat = true;
            this.$message({showClose: true, message: "有API正在监控中，请检查！", type: 'error'});
            break
          }
        }

      }
      if (!this.checkRepeat) {
        this.saveMoreApiMonitor(flag)
      }

    },
    saveMoreApiMonitor(flag) {
      let id = this.apiId ? this.apiId : null;
      let isTest = true;
      if (flag == "false") {
        isTest = false;
      } else if (flag == "true") {
        isTest = true;
      }
      let data = {
        'guid': id,
        'group': this.moreForm.group,
        'name': this.moreForm.name,
        'monitorType': "SEQUENCE",
        'frequency': parseInt(this.moreForm.frequency),
        'remark': this.moreForm.remark,
        'mailfrequency': parseInt(this.moreForm.mailfrequency),
        'singleMonitorInfo': this.moreData,
        'isTest': isTest,
      };
      this.$axios.post(this.apiUrl + 'apimonitor/updateSequenceMonitor', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (isTest == true) {
              this.moreresultTestView = true;
              this.testResultData = data;
            } else {
              this.moremonitorView = false;
              this.initMonitorList();
            }
          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    saveOneConfirm(flag) {
      if (this.oneForm.url && this.oneForm.group && this.oneTitle == "添加单API监控") {
        let data = {
          'url': this.oneForm.url,
          'group': this.oneForm.group,
        };
        this.$axios.post(this.apiUrl + 'apimonitor/checkUrl', data)
          .then(({data: {msg, data, code}}) => {
            if (code == -1) {
              this.$message({
                  duration: 5000,
                  showClose: true,
                  message: "该URL正在监控中，请重新输入！",
                  type: 'error'
                }
              )
            } else {
              this.saveOneApiMonitor(flag)
            }
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        this.saveOneApiMonitor(flag)
      }
    },
    saveOneApiMonitor(flag) {
      let isTest = true;
      if (flag == "false") {
        isTest = false;
      } else if (flag == "true") {
        isTest = true;
      }
      let frequency = "";
      if (this.oneForm.frequency == "free") {
        frequency = this.oneForm.freeFrequency
      } else {
        frequency = this.oneForm.frequency
      }

      let mailfrequency = "";
      if (this.oneForm.mailfrequency == "free") {
        mailfrequency = this.oneForm.freeMailfrequency
      } else {
        mailfrequency = this.oneForm.mailfrequency
      }
      let id = this.apiId ? this.apiId : null;
      let data = {
        'guid': id,
        'group': this.oneForm.group,
        'name': this.oneForm.name,
        'monitorType': "SINGLE",
        'httpMethod': this.oneForm.httpMethod,
        'url': this.oneForm.url,
        'frequency': parseInt(frequency),
        'headers': this.oneForm.headers,
        'parameters': this.oneForm.parameters,
        'conditionType': this.oneForm.conditionType,
        'condition': this.oneForm.condition,
        'remark': this.oneForm.remark,
        'isTest': isTest,
        'mailfrequency': parseInt(mailfrequency),
        'retryNum': parseInt(this.oneForm.retryNum),
      };
      this.$axios.post(this.apiUrl + 'apimonitor/updateSingleMonitor', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (isTest == true) {
              this.resultTestView = true;
              this.result = msg;
            } else {
              this.monitorView = false;
              this.initMonitorList();
            }
          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    //添加多API的接口校验
    checkMoreApi() {
      this.moreData.forEach(e => {
        let data = {
          'url': e.url,
          'group': this.moreForm.group,
        };
        this.$axios.post(this.apiUrl + 'apimonitor/checkUrl', data)
          .then(({data: {msg, data, code}}) => {
            if (code == -1) {
              this.$message({
                  duration: 8000,
                  showClose: true,
                  message: "此系统下 " + e.url + " 已在监控中，请检查！",
                  type: 'error'
                }
              );
              e.checkRepeat = true
            }
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    //导入postman脚本
    exportPostman() {
      let obj = {};
      obj = JSON.parse(this.postmanText);
      let data = {
        'info': obj.info,
        'item': obj.item
      };
      this.$axios.post(this.apiUrl + "apimonitor/transcodePostmanJson", data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.importView = false;
            this.moreData = data;
            this.checkMoreApi();
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getSystemList() {
      this.$axios.get(this.apiUrl + 'apimonitor/getGroup')
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.systemList = data;
          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    delOneApi(item) {
      let oneId = item.guid;
      let data = {
        'guid': oneId
      };
      this.$confirm('是否确认删除该API监控?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.apiUrl + 'apimonitor/deleteSingleMonitor', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.initMonitorList();
            } else {
              this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    onApi(item) {
      let onId = item.guid;
      let isStatus;
      if (item.enable == 1) {
        isStatus = false;
        this.enableShow = false;
      } else {
        isStatus = true;
        this.enableShow = true;
      }
      let url = this.apiUrl
        + "apimonitor/enableMonitor/"
        + onId + '/'
        + isStatus;
      this.$axios.post(url)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.$message({
              showClose: true,
              message: '执行成功！',
              type: 'success',
              customClass: "my-message"
            });
            this.initMonitorList();
          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // apiTestClose() {
    //   this.apiTestView = false;
    // },
    // testApi() {
    //   this.apiTestView = true;
    // },
    editClose() {
      this.APIView = false;
    },
    editMoreApi(index, item) {
      this.editIndex = index;
      this.APIView = true;
      this.apiTitle = "编辑API";
      this.apiForm.httpMethod = item.httpMethod;
      this.apiForm.url = item.url;
      this.apiForm.headers = item.headers;
      this.apiForm.parameters = item.parameters;
      this.apiForm.conditionType = item.conditionType;
      this.apiForm.variables = item.variables;
      this.apiForm.condition = item.condition;
      this.apiForm.resulttype = item.resulttype;
    },
    addNewApi() {
      this.editIndex = "";
      this.APIView = true;
      this.apiTitle = "新增API";
      this.apiForm.httpMethod = "";
      this.apiForm.url = "";
      this.apiForm.headers = "";
      this.apiForm.parameters = "";
      this.apiForm.conditionType = "";
      this.apiForm.condition = "";
      this.apiForm.resulttype = "";
      this.apiForm.variables = "";
    },
    importScript() {
      this.importView = true;
      this.postmanText = "";
    },
    getOneApi() {
      let data = {
        'guid': this.apiId,
      };
      this.$axios.post(this.apiUrl + 'apimonitor/getSingleMonitor', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.oneForm.group = data.group;
            this.oneForm.name = data.name;
            this.oneForm.httpMethod = data.httpMethod;
            this.oneForm.url = data.url;

            this.oneForm.headers = data.headers;
            this.oneForm.parameters = data.parameters;
            this.oneForm.conditionType = data.conditionType;
            this.oneForm.condition = data.condition;
            this.oneForm.remark = data.remark;
            this.oneForm.retryNum = data.retryNum;

            if (data.mailfrequency == "30" || data.mailfrequency == "60" || data.mailfrequency == "300"
              || data.mailfrequency == "600" || data.mailfrequency == "0") {
              this.oneForm.mailfrequency = data.mailfrequency;
            } else {
              this.oneForm.mailfrequency = "free";
              this.oneForm.freeMailfrequency = data.mailfrequency
            }

            if (data.frequency == "30" || data.frequency == "60" || data.frequency == "300"
              || data.frequency == "600" || data.frequency == "1800" || data.frequency == "3600") {
              this.oneForm.frequency = data.frequency;
            } else {
              this.oneForm.frequency = "free";
              this.oneForm.freeFrequency = data.frequency
            }
          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getMoreApi() {
      let data = {
        'guid': this.apiId,
      };
      this.$axios.post(this.apiUrl + 'apimonitor/getSequenceMonitor', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.moreForm.group = data.group;
            this.moreForm.name = data.name;
            this.moreForm.frequency = data.frequency;
            this.moreData = data.singleMonitorInfo;
            this.moreForm.remark = data.remark;

            if (data.mailFrequency != "30" && data.mailFrequency != "60"
              && data.mailFrequency != "300" && data.mailFrequency != "600") {
              this.moreForm.mailfrequency = data.mailFrequency + "秒";
            } else {
              this.moreForm.mailfrequency = data.mailFrequency;
            }

            if (data.frequency != "30" && data.frequency != "60"
              && data.frequency != "300" && data.frequency != "600" && data.frequency != "6000" && data.frequency != "12000") {
              this.moreForm.frequency = data.frequency + "秒";
            } else {
              this.moreForm.frequency = data.frequency;
            }
          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    deployApi(item) {
      if (item.type == "SINGLE") {
        this.monitorView = true;
        this.oneTitle = "编辑单API监控";
        this.apiId = item.guid;
        this.getOneApi();
        this.getSystemList();
      } else {
        this.moremonitorView = true;
        this.moreTitle = "编辑多API监控";
        this.getSystemList();
        this.apiId = item.guid;
        this.getMoreApi();
      }
    },
    addSystem() {
      this.addSystemView = true;
      this.addSystemForm.systemName = "";
    },
    saveSystem() {
      let data = {
        'id': this.systemId,
        'name': this.addSystemForm.systemName,
      };
      this.$axios.post(this.apiUrl + 'apimonitor/addGroup', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.addSystemView = false;
            this.getSystemList();
          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.initMonitorList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.initMonitorList();
    },
    addMonitor(command) {
      if (command == 'one') {
        this.monitorView = true;
        this.oneTitle = "添加单API监控";
        this.getSystemList();
        this.apiId = "";
        this.oneForm.group = "";
        this.oneForm.name = "";
        this.oneForm.httpMethod = "";
        this.oneForm.url = "";
        this.oneForm.frequency = "";
        this.oneForm.headers = "";
        this.oneForm.parameters = "";
        this.oneForm.conditionType = "";
        this.oneForm.condition = "";
        this.oneForm.remark = "";
        this.oneForm.mailfrequency = ""
      } else if (command == 'more') {
        this.moremonitorView = true;
        this.getSystemList();
        this.moreTitle = "添加多API监控";
        this.apiId = "";
        this.moreForm.group = "";
        this.moreForm.name = "";
        this.moreForm.frequency = "";
        this.moreData = [];
        this.moreForm.remark = "";
        this.moreForm.mailfrequency = "";
      }
    }
  }
}
</script>

<style>
.el-tooltip__popper {
  max-width: 1000px;
  background: #fcf2ff !important;
  color: #000 !important;
}

/*textarea {*/
/*  white-space: pre-wrap;*/
/*}*/
.my-message {
  min-width: 150px !important;
  width: 150px !important;
}
</style>
